
 import adminUrls from "@/urls/events";
import {
  sendGetRequest,
} from "@/helper/requests";


const state = {
  events: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: {},
    error: null,
  }
};

const getters = {
  getEvents: state => state.events.items,
  getEventsCount: state => state.events.count,
  getCurrentUrl: state => state.events.currentUrl,
  getEventsDetail: state => state.events.detail,
  isLoadingEvents: state => state.events.loading,
  saveEventsError: state => state.events.error,
};

const actions = {
  loadEventsDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) url = adminUrls.ADMIN.EVENTS.DETAIL(id)
    sendGetRequest(
        url, (data, url) => {
          commit('SET_EVENTS_DETAIL', data);
          finalizer(data, url);
        }, (data, url) => {
          commit('SAVE_EVENTS_ERROR', data);
          catcher(data, url);
        }
    )
  },
  loadEventsList: ({commit, getters}, {url, urlAppend, finalizer=()=>{}, catcher=()=>{}}) => {
    if (!url) {
      url = adminUrls.ADMIN.EVENTS.LIST()
      if (urlAppend) url = urlAppend(url)
    }
    if (!getters.isLoadingEvents) {
      commit('SET_EVENTS_LOADING');
      sendGetRequest(
        url, (data, url) => {
          for (let i in data['results']) {
               data['results'][i].fio= "-"
          }
          commit('SET_EVENTS', data['results']);
          commit('SET_EVENTS_COUNT', data['count']);
          commit('SET_EVENTS_CURRENT_URL', url);
          commit('SET_EVENTS_LOADING_END');
          finalizer(data, url);
        }, (data, url) => {
          commit('SET_EVENTS_LOADING_END');
          commit('SAVE_EVENTS_ERROR', data);
          catcher(data, url);
        }
      )
    }
  },
};

const mutations = {

  SET_EVENTS: (state, obj) => {
    state.events.items = obj
  },
  SET_EVENTS_DETAIL: (state, value) => {
    state.events.detail = value
  },
  SET_EVENTS_COUNT: (state, value) => {
    state.events.count = value
  },
  SET_EVENTS_CURRENT_URL: (state, value) => {
    state.events.currentUrl = value
  },
  SET_EVENTS_LOADING: (state) => {
    state.events.loading = true
  },
  SET_EVENTS_LOADING_END: (state) => {
    state.events.loading = false
  },
  SAVE_EVENTS_ERROR: (state, error) => {
    state.events.error = error
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}


